export const MAX_DATE_RANGE_IN_DAYS = 365
export const MAX_DATE_RANGE_IN_DAYS_THREE_YEARS = 365 * 3

const toDateOnly = date => {
  const copy = new Date(date)
  copy.setUTCHours(0, 0, 0, 0)
  return copy
}

export const clampDateRange = (start, end, maxDays = MAX_DATE_RANGE_IN_DAYS) => {
  const startDate = new Date(start)
  const endDate = new Date(end)

  const normalizedStart = new Date(Math.min(startDate.getTime(), endDate.getTime()))
  const normalizedEnd = new Date(Math.max(startDate.getTime(), endDate.getTime()))
  const maxDelta = maxDays * 24 * 60 * 60 * 1000

  if (normalizedEnd.getTime() - normalizedStart.getTime() <= maxDelta) {
    return {
      start: toDateOnly(normalizedStart),
      end: toDateOnly(normalizedEnd)
    }
  }

  const clampedStart = new Date(normalizedEnd)
  clampedStart.setUTCDate(clampedStart.getUTCDate() - maxDays)

  return {
    start: toDateOnly(clampedStart),
    end: toDateOnly(normalizedEnd)
  }
}

export const filterPointsByDateRange = (points, start, end) => {
  const rangeStart = toDateOnly(start)
  const rangeEnd = toDateOnly(end)

  return points.filter(point => {
    const pointDate = new Date(`${point.date}T00:00:00.000Z`)
    return pointDate >= rangeStart && pointDate <= rangeEnd
  })
}
